export default {
	name: 'LogoutCallback',
	beforeCreate() {
		this.$store.dispatch('auth/signoutRedirectCallback');
	},
};